import { EventEmitter, Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class DataTableEventsService {

  constructor() { }

  tableDataRows = new Subject();

  tableHeaders = new Subject();

  nextLevel = new Subject();

  handleClick = new Subject();

  sortOptions = new Subject();

  searchFilterOptions = new Subject();

  searchFilter = new Subject();

  sortHeader = new Subject();

  toggleColumns = new Subject();

  recordData = new Subject<object[]>();

  downloadTable = new Subject();

  togglePage = new Subject();

  initSubject: { [key: string]: Subject<Boolean> } = {};

  invokeToolbarComponentFunction = new EventEmitter();    
  subsVar: Subscription;

  dataTableSubjects: string[] = ["sortOptions", "togglePage", "breadcrumbClicked", "popupCalled", "recordData", "totalData", "data", "callbackCalled", "tableHeaderExpansion"];

  dataTableConfigSubjects: { [tableId: string]: { [key: string]: Subject<any> } } = {};

  addInitSubject(id){
    if(!this.initSubject[id]){
      this.initSubject[id] = new Subject<Boolean>();
    }
  }
  onToolbarComponentButtonClick() {    
    this.invokeToolbarComponentFunction.emit();    
  }  

  /**
 * create data table subject based on id
 * @param id Table id
 */
  createDataTableSubject(id) {
    if (!isNullOrUndefined(id) && !this.dataTableConfigSubjects[id]) {
      let dataTableSubjectsObject = {};
      this.dataTableSubjects.forEach(sub => {
        dataTableSubjectsObject[sub] = new Subject<any>();
      })
      this.dataTableConfigSubjects[id] = dataTableSubjectsObject;
      // this.initSubject[id].next(true);
    }
  }

  clearAllSubjectsForTable(id){
    if(this.dataTableConfigSubjects[id]){
      delete this.dataTableConfigSubjects[id];
    }
  }
}